module.exports = __webpack_public_path__ + "img/117.b6656bb0.jpg";